import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  IconButton,
  TextField,
  MenuItem,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";

function FindDriverModal({ modalOpen, setModalOpen }) {
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedDriver, setSelectedDriver] = useState("");

  // Dummy data for states, cities, and drivers
  const states = ["State A", "State B", "State C"];
  const cities = {
    "State A": ["City X", "City Y"],
    "State B": ["City Z", "City W"],
    "State C": ["City P", "City Q"],
  };
  const availableDrivers = [
    { id: "driver1", name: "John Doe" },
    { id: "driver2", name: "Jane Smith" },
    { id: "driver3", name: "Peter Jones" },
    { id: "driver4", name: "Alice Brown" },
  ];

  const handleStateChange = (event) => {
    setSelectedState(event.target.value);
    setSelectedCity(""); // Reset city when state changes
  };

  const handleCityChange = (event) => {
    setSelectedCity(event.target.value);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleDriverChange = (event) => {
    setSelectedDriver(event.target.value);
  };

  const handleAssignDriver = () => {
    console.log("Assign Driver clicked. Selected Driver:", selectedDriver);
    setModalOpen(false);
    // Add your logic to assign the driver here
  };

  const filteredDrivers = availableDrivers.filter((driver) =>
    driver.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
      <Box
        sx={{
          bgcolor: "white",
          p: 3,
          borderRadius: 2,
          width: "90%",
          maxWidth: 600,
          maxHeight: "90vh",
          overflowY: "auto",
          mx: "auto",
          mt: 5,
          position: "relative",
        }}
      >
        {/* Modal Header */}
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
          <Typography fontWeight={600} fontSize="18px">
            Find Driver
          </Typography>
          <IconButton onClick={() => setModalOpen(false)}>
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Start building UI here */}
        <Box sx={{ mb: 3 }}>
          <Typography fontWeight={500} fontSize="16px" sx={{ mb: 1 }}>
            Find Closest Driver
          </Typography>
          <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
            <FormControl fullWidth>
              <TextField
                select
                label="State"
                value={selectedState}
                onChange={handleStateChange}
                size="small"
              >
                {states.map((state) => (
                  <MenuItem key={state} value={state}>
                    {state}
                  </MenuItem>
                ))}
              </TextField>
            </FormControl>
            <FormControl fullWidth>
              <TextField
                select
                label="City"
                value={selectedCity}
                onChange={handleCityChange}
                size="small"
                disabled={!selectedState} // Disable city selection until a state is chosen
              >
                {selectedState &&
                  cities[selectedState].map((city) => (
                    <MenuItem key={city} value={city}>
                      {city}
                    </MenuItem>
                  ))}
              </TextField>
            </FormControl>
          </Box>
          <TextField
            fullWidth
            placeholder="Select"
            variant="outlined"
            size="small"
            value={searchQuery}
            onChange={handleSearchChange}
            InputProps={{
              endAdornment: <SearchIcon color="action" />,
            }}
            sx={{ mb: 2 }}
          />
          <Typography fontWeight={500} fontSize="14px" sx={{ mb: 1 }}>
            Available Drivers
          </Typography>
          <FormControl component="fieldset" fullWidth>
            <RadioGroup
              aria-label="available-drivers"
              name="available-drivers"
              value={selectedDriver}
              onChange={handleDriverChange}
            >
              {filteredDrivers.length > 0 ? (
                filteredDrivers.map((driver) => (
                  <FormControlLabel
                    key={driver.id}
                    value={driver.id}
                    control={<Radio size="small" />}
                    label={driver.name}
                    sx={{
                      "& .MuiFormControlLabel-label": {
                        fontSize: "14px",
                      },
                    }}
                  />
                ))
              ) : (
                <Typography variant="body2" color="textSecondary">
                  No drivers found.
                </Typography>
              )}
            </RadioGroup>
          </FormControl>
        </Box>

        {/* Action Buttons */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 2,
            mt: 3,
            pt: 2, // Add padding top to create a separation from the content above
            borderTop: "1px dashed #e0e0e0", // Dashed border as seen in some UI patterns
          }}
        >
          <Button
            variant="outlined"
            onClick={() => setModalOpen(false)}
            sx={{
              color: "text.primary",
              borderColor: "grey.400",
              "&:hover": {
                borderColor: "grey.600",
              },
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleAssignDriver}
            disabled={!selectedDriver} // Disable if no driver is selected
            sx={{
              bgcolor: "black",
              "&:hover": {
                bgcolor: "grey.800",
              },
            }}
          >
            Assign Driver
          </Button>
        </Box>
        {/* End building UI here */}
      </Box>
    </Modal>
  );
}

export default FindDriverModal;
